import { useCallback, useState } from 'react';
import { parseError } from '@/utils';
import { DormitoryHttp } from '@/services';

export default function useDormitorySolitaryBlocks() {
  const [blocks, setBlocks] = useState<IdName[]>([]);
  const [blocksError, setError] = useState('');
  const [blocksLoading, setLoading] = useState(false);

  const fetchBlocks = useCallback(async (id: number) => {
    setLoading(true);
    try {
      const res = await DormitoryHttp.fetchSolitaryBlocks(id);
      setBlocks(res.data.payload ?? []);
    }
    catch (e) {
      setError(parseError(e));
    }
    finally {
      setLoading(false);
    }
  }, []);

  return { fetchBlocks, blocks, blocksLoading, blocksError };
}
